'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    carouselAutoplayButtonClassNames: function() {
        return carouselAutoplayButtonClassNames;
    },
    useCarouselAutoplayButtonStyles_unstable: function() {
        return useCarouselAutoplayButtonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _reactbutton = require("@fluentui/react-button");
const carouselAutoplayButtonClassNames = {
    root: 'fui-CarouselAutoplayButton',
    icon: 'fui-CarouselAutoplayButton__icon'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bkecrkj: "fc5wo7j",
        B6of3ja: "fgr6219",
        jrapky: "f10jk5vf",
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        sj55zd: "fkfq4zb",
        De3pzq: "fkfdr9r",
        eoavqd: "f8491dx"
    }
}, {
    d: [
        ".fc5wo7j{pointer-events:all;}",
        ".fgr6219{margin-top:auto;}",
        ".f10jk5vf{margin-bottom:auto;}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".fkfq4zb{color:var(--colorNeutralForeground2);}",
        ".fkfdr9r{background-color:var(--colorNeutralBackgroundAlpha);}"
    ],
    h: [
        ".f8491dx:hover{cursor:pointer;}"
    ]
});
const useCarouselAutoplayButtonStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    (0, _reactbutton.useToggleButtonStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(carouselAutoplayButtonClassNames.root, styles.root, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(carouselAutoplayButtonClassNames.icon, state.icon.className);
    }
    return state;
};
